import { AsyncPipe } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    signal,
    WritableSignal,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslatePipe } from '@ngx-translate/core';
import { SentEmailModel } from 'lemunzo-api';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { Observable } from 'rxjs';
import { PrimeNGTableColModel } from '../../models/primeng-table-col-model';
import { TranslateDatePipe } from '../../pipes/translate-date.pipe';
import { PrimengLocaleService } from '../../services/primeng-locale.service';
import { TableConfigService } from '../../services/table-config.service';
import { PrimeNGNoRecordsComponent } from '../primeng-no-records/primeng-no-records.component';

@Component({
    selector: 'apcam-sent-email-list',
    templateUrl: './sent-email-list.component.html',
    styleUrl: './sent-email-list.component.scss',
    imports: [
        AsyncPipe,
        MatCardModule,
        PrimeNGNoRecordsComponent,
        TableModule,
        TranslateDatePipe,
        TranslatePipe,
    ],
})
export class SentEmailListComponent implements OnInit {
    @Input()
    public items: WritableSignal<SentEmailModel[]> = signal([]);

    @Input()
    public totalCount: WritableSignal<number> = signal(0);

    @Output()
    public readonly queryData = new EventEmitter<TableLazyLoadEvent>();

    @Output()
    public readonly emailLogDetail = new EventEmitter<number>();

    protected readonly columns: PrimeNGTableColModel[] = [
        {
            field: 'recipientEmail',
            label: 'shared.sentEmailList.columns.recipientEmail',
            sort: true,
        },
        {
            field: 'senderEmail',
            label: 'shared.sentEmailList.columns.senderEmail',
            sort: true,
        },
        {
            field: 'sentAtUtc',
            label: 'shared.sentEmailList.columns.sentAtUtc',
            sort: true,
        },
        {
            field: 'subject',
            label: 'shared.sentEmailList.columns.subject',
            sort: true,
        },
    ];
    protected readonly tableRowDefault = TableConfigService.TableRowDefault;
    protected readonly tableRowsOptions = TableConfigService.TableRowsOptions;

    protected loading: WritableSignal<boolean> = signal(false);
    protected locale$: Observable<string> | undefined = new Observable();
    protected tableCurrentPageReportTemplate: WritableSignal<string> =
        signal('');

    constructor(private readonly primengLocaleService: PrimengLocaleService) {}

    ngOnInit(): void {
        this.locale$ = this.primengLocaleService.getLocale();
    }
}
